import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original.url || "";
    const isExcludedAuth = ["/auth/login", "/auth/logout", "/auth/refresh"].some((p) => url.includes(p));
    if (error.response?.status === 401 && !original._retry && !isExcludedAuth) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        await refreshPromise;
        return api(original);
      } catch (e) {
        if (window.location.pathname !== "/login") window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export default api;
